import Spinner from 'components/Spinner'
import React from 'react'
import styled from '@emotion/styled'
import ScrollToTop from 'components/ScrollToTop'

const QueryWrapper = ({ loading, error, children }) => {
  if (error) {
    return (
      <ScrollToTop>
        <ErrorMessage>
          An error occured, please check your network connection
        </ErrorMessage>
      </ScrollToTop>
    )
  }
  if (loading) {
    return (
      <ScrollToTop>
        <Spinner />
      </ScrollToTop>
    )
  }
  return <ScrollToTop>{children}</ScrollToTop>
}

export default QueryWrapper

const ErrorMessage = styled('h1')`
  text-align: center;
  margin-top: 40px;
`
